export interface Survey {
    survey_id: string
    survey_url: string
    title: string
}
export const LAST_INTERACTED_SURVEY_TIME = 'LAST_INTERACTED_SURVEY_TIME'